import { FC, ReactNode } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Action } from '../../atoms';
import { useMsal } from '@azure/msal-react';
import styles from './MenuBar.module.css';

interface MenuBarProps {
  children: ReactNode;
  onSelect?: (id: string | null) => void;
}

const MenuBar: FC<MenuBarProps> = ({ children, onSelect }) => {
  const { instance } = useMsal();

  const logout = () => {
    instance.logoutRedirect();
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary" onSelect={onSelect}>
      <Container>
        <img
          className={styles.logo}
          src={require('../../../assets/images/DC_SourceUp_Theme.Logo.png')}
          alt={''}
        />
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">{children}</Nav>
        </Navbar.Collapse>
        <Action type="logout" size="sm" color="dark" onClick={logout} />
      </Container>
    </Navbar>
  );
};

export default MenuBar;
